import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;

  position: relative;

  & > button {
    position: absolute;
    right: 13px;
    background: transparent;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 13px;
  margin-bottom: 0px !important;

  border-radius: ${theme.border.mediumRadius};
  border: 1px solid ${theme.colors.gray300};
  background-color: ${theme.colors.darkBlue};
  font-size: 16px !important;
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.poppins};
  color: ${theme.colors.white};
  font-weight: ${theme.font.normal};

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${theme.colors.gray400};
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${theme.colors.gray400};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${theme.colors.gray400};
  }

  @media screen and (max-width: 768px) {
    background-color: ${theme.colors.blue900};
  }
`;
